import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const passwordResetService = {
    getAllPasswordReset,
    resend
};

const MODULE = {
    PASSWORD_RESET: 'password-resets',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllPasswordReset(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }

    let arr = filter.searchArray
    arr.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })

  
    return apiHelper(API_URL).get(`/${MODULE.PASSWORD_RESET}`, requestOptions)
  }


  export function resend(data) {
    const requestOptions = {
      otp: data.otp,
      purpose: data.purpose,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.PASSWORD_RESET}/resend`, requestOptions)
  }